export const EXPANDED_ROW_FONT_WEIGHT = 600;
export const DEFAULT_FONT_WEIGHT = 400;

export const EXPANDED_ROW_FONT_SIZE = 1;
export const DEFAULT_FONT_SIZE = 0.875;
